/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */

import { createReducer } from 'reduxsauce';
import { LspDeliveryProcessTypes } from './Actions';
import INITIAL_STATE from './InitialState';

export const lspDeliveryProcessFetchLspDeliveryProcessLoading = (state, { boolean }) => ({
  ...state,
  processIsLoading: boolean
});

export const lspDeliveryProcessFetchLspDeliveryProcessSuccess = (state, { process }) => ({
  ...state,
  process
});

export const lspDeliveryProcessShowSyncSettingLoading = (state, { boolean }) => ({
  ...state,
  syncIsLoading: boolean
});

export const lspDeliveryProcessShowSyncSettingSuccess = (state, { syncSetting }) => ({
  ...state,
  syncSetting
});
/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [LspDeliveryProcessTypes.LSP_DELIVERY_PROCESS_FETCH_LSP_DELIVERY_PROCESS_LOADING]: lspDeliveryProcessFetchLspDeliveryProcessLoading,
  [LspDeliveryProcessTypes.LSP_DELIVERY_PROCESS_FETCH_LSP_DELIVERY_PROCESS_SUCCESS]: lspDeliveryProcessFetchLspDeliveryProcessSuccess,

  [LspDeliveryProcessTypes.LSP_DELIVERY_PROCESS_SHOW_SYNC_SETTING_LOADING]: lspDeliveryProcessShowSyncSettingLoading,
  [LspDeliveryProcessTypes.LSP_DELIVERY_PROCESS_SHOW_SYNC_SETTING_SUCCESS]: lspDeliveryProcessShowSyncSettingSuccess
});
